module.exports = __webpack_public_path__ + "static/montserrat-v12-latin-300-5e86df2cad22d2ef2b03516334afae5e.woff";